module.exports = __webpack_public_path__ + "static/media/debriefer-icon.ee6ca358.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/icons/debriefer-icon.svg
// module id = 309
// module chunks = 0